import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Wrapper } from '../common';
import { Testimonials } from '../testimonials';
import { convertColorToHex } from '../../util/helpers';
import './TestimonialsBlock.scss';

const TYPE_KID = 'kid';
const TYPE_ADULT = 'adult';

const TestimonialsBlock = (props) => {
  const {
    data,
    isHome,
  } = props;
  const {
    primary,
    items: testimonials,
  } = data;
  const {
    sectionTheme,
  } = primary;
  if (!testimonials || testimonials.length < 1) return null;
  const sectionHex = sectionTheme ? convertColorToHex(sectionTheme) : null;
  const [adultsHeight, setAdultsHeight] = useState(0);
  const [kidsHeight, setKidsHeight] = useState(0);
  const [activeType, setActiveType] = useState(TYPE_KID);
  const [isAnimating, setAnimating] = useState(false);
  const changeActiveType = (event, newType) => {
    if (event) event.preventDefault();
    if (newType !== activeType) {
      setAnimating(true);
      setTimeout(() => {
        setActiveType(newType);
        setTimeout(() => {
          setAnimating(false);
        }, 300);
      }, 300);
    }
  };
  let ref = null;
  let inView = null;
  if (isHome) {
    const [inViewRef, inViewBool] = useInView({
      /* Optional options */
      threshold: 0.2,
    });
    ref = inViewRef;
    inView = inViewBool;
    useEffect(() => {
      if (inView) document.documentElement.style.setProperty('--bg-colour', sectionHex);
    }, [inView]);
  }
  let kidsTestimonials = testimonials.filter(testimonial => testimonial.type.toLowerCase() === TYPE_KID);
  if (kidsTestimonials.length > 3) kidsTestimonials = kidsTestimonials.slice(0, 3);
  let adultsTestimonials = testimonials.filter(testimonial => testimonial.type.toLowerCase() === TYPE_ADULT);
  if (adultsTestimonials.length > 3) adultsTestimonials = adultsTestimonials.slice(0, 3);
  return (
    <div className="testimonials-block" ref={isHome ? ref : ''}>
      <Wrapper isBound>
        <h2 className="title">
          <span>What</span>
          <button
            className={`type-selector${activeType === TYPE_KID ? ' active' : ''}`}
            type="button"
            aria-label="Go to next slide"
            onClick={event => changeActiveType(event, TYPE_KID)}
          >
            <span>kids</span>
          </button>
          <span>/</span>
          <button
            className={`type-selector${activeType === TYPE_ADULT ? ' active' : ''}`}
            type="button"
            aria-label="Go to next slide"
            onClick={event => changeActiveType(event, TYPE_ADULT)}
          >
            <span>adults</span>
          </button>
          <span>say...</span>
        </h2>
        <div
          className="testimonials-container"
          style={{ height: `${kidsHeight > adultsHeight ? kidsHeight : adultsHeight}px` }}
        >
          <Testimonials
            testimonials={kidsTestimonials}
            isActive={activeType === TYPE_KID}
            isAnimating={isAnimating}
            setHeightHandler={setKidsHeight}
          />
          <Testimonials
            testimonials={adultsTestimonials}
            isAnimating={isAnimating}
            isActive={activeType === TYPE_ADULT}
            setHeightHandler={setAdultsHeight}
          />
        </div>
      </Wrapper>
    </div>
  );
};

export default TestimonialsBlock;
